import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class LoadMoreNews {

    constructor() {
        this.settings = {
            $newsList: $(".js-news-list")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$newsList != null) {

            let newsList = this.settings.$newsList; // The container element that holds the list of news articles
            let loadNr = $('#js-nr-news-default').val(); // The number of articles to load
            let loadMoreBtn = $(".js-load-more-news"); // The button that triggers the loading of more articles

            function newsTypeList() {
                // Remove hidden class from all the articles
                $('.js-news-single').removeClass('hidden');

                newsList.find('.js-news-single').each(function (index) {

                    // Hide articles that have a higher index than the number of articles to load
                    if (index >= loadNr) {
                        $(this).addClass('hidden');
                    }
                });
            }

            newsTypeList();

            // Hide the load more button if there are no more reports to load initially
            if (newsList.find('.hidden').length === 0) {
                loadMoreBtn.removeClass('btn');
                loadMoreBtn.addClass('hidden');
            }

            // Load more articles when the button is clicked
            loadMoreBtn.on('click',  (e) => {

                const $this = e.currentTarget;

                let moreNews =  newsList.find('.hidden'); // The articles that are currently hidden
                let counter = 0; // Counter to keep track of the number of articles that have been shown
                moreNews.each(function () {

                    // Stop the loop when the number of articles that have been shown is equal to the number of articles to load
                    if (counter >= loadNr) {
                        return false;
                    }

                    // Increment the counter
                    counter++;

                    // Show the articles
                    $(this).removeClass('hidden');
                });

                // Hide the load more button if there are no more articles to load
                if (newsList.find('.hidden').length === 0) {
                    $this.classList.remove('btn');
                    $this.classList.add('hidden');
                }

                ScrollTrigger.refresh();
            });

        }

    }
};

new LoadMoreNews();